import React, { useEffect, useState } from 'react';
import './career.scss';
import 'aos/dist/aos.css';
import { Pagination, AutoComplete, Button, Select } from 'antd';
import FooterId from '../footer/FooterId';
import FooterEn from '../footer/FooterEn';
import metaThumbnail from '../data/images/meta/homeimage.png';
import MetaDecorator from '../Util/MetaDecorator';
import CareerDetailEn from './careerdetail/CareerDetailEn';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import BASE_URL from '../Util/config';

const career = require('../data/json/career.json');

const Career = () => {
  const isIdPath = window.location.pathname.startsWith('/en');
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedLoker, setSelectedLoker] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [newData, setNewData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCareers = async () => {
      try {
        setLoading(true);

        const response = await axios.get(`${BASE_URL}/api/careers-cms?company=1`);

        // Console log untuk response
        // console.log('Response Status:', response.status);
        // console.log('Response Full:', response.data);
        // console.log('Success:', response.data.success);
        // console.log('Message:', response.data.message);
        // console.log('Data Array:', response.data.data);
        // console.log('Data Array Length:', response.data.data?.length);
        // if (response.data.data && response.data.data.length > 0) {
        //   console.log('Sample Item:', response.data.data[0]);
        // }

        // Ambil array dari response.data.data
        const dataArray = response.data.data || [];

        // Filter data berdasarkan approvalStatus dan status sebelum transform
        const filteredRawData = dataArray.filter((item) => item.approvalStatus === 'published' && item.status === true);

        // console.log('Filtered Raw Data (approvalStatus === "published" && status === true):', filteredRawData);
        // console.log('Total Filtered Raw Data:', filteredRawData.length);

        const transformedData = filteredRawData.map((item) => ({
          id: item.id,
          name: item.name_en,
          content: item.description_en || '',
          department: item.department || '',
          location: item.location || '',
          status_posting: item.status !== undefined ? item.status : true,
          type: item.type || '',
          education: item.education || '',
          experience: item.experience || '',
          salary: item.salary || 0,
          salaryType: item.salaryType || '',
          totalNeeded: item.totalNeeded || 0,
          requirements: item.requirements_en || [],
          responsibilities: item.responsibilities_en || [],
        }));

        // console.log('Transformed Data:', transformedData);
        // console.log('Total Transformed:', transformedData.length);

        setNewData(transformedData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching careers:', error);
        console.error('Error message:', error.message);
        if (error.response) {
          console.error('Error response data:', error.response.data);
          console.error('Error response status:', error.response.status);
        }
        setLoading(false);
      }
    };

    fetchCareers();
  }, []);

  const handleDepartmentChange = (value) => {
    setSelectedDepartment(value);
    setCurrentPage(1);
  };

  const handleLocationChange = (value) => {
    setSelectedLocation(value);
    setCurrentPage(1);
  };

  const handleSearchChange = (value) => {
    setSearchValue(value);
    setCurrentPage(1);
  };

  const handleBodyClick = (id) => {
    setSelectedLoker(id);
    setOpen(true);
  };

  const uniqueDepartments = [...new Set(newData.map((career) => career.department))];
  const uniqueLocations = [...new Set(newData.map((career) => career.location))];

  const departmentOptions = [{ value: null, label: 'All Department' }, ...uniqueDepartments.map((department) => ({ value: department, label: department }))];

  const locationOptions = [{ value: null, label: 'All Location' }, ...uniqueLocations.map((location) => ({ value: location, label: location }))];

  const sortedDepartmentOptions = [departmentOptions[0], ...departmentOptions.slice(1).sort((a, b) => a.label.localeCompare(b.label))];

  const sortedLocationOptions = [locationOptions[0], ...locationOptions.slice(1).sort((a, b) => a.label.localeCompare(b.label))];

  const filteredCareers = newData.filter((career) => {
    return (!selectedDepartment || career.department === selectedDepartment) && (!selectedLocation || career.location === selectedLocation);
  });

  const filteredPositions = filteredCareers.filter((career) => {
    return career.name?.toLowerCase().includes(searchValue.toLowerCase());
  });

  const totalDisplayedData = filteredPositions.length;
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, totalDisplayedData);

  return (
    <div>
      <MetaDecorator description={career.pageDescriptionEn} title={career.pageTitleEn} imageUrl={metaThumbnail} imageAlt={career.metaImageAltEn} />
      <div className="contentCareer" data-aos="fade-down">
        <div className="career-content d-flex align-items-center justify-content-center">
          <div className="content-text">
            <h1 className="textHero" data-aos="fade-up">
              Be One Step Closer <br /> to Achieving Your Goals.
            </h1>
          </div>
        </div>
        <div className="bottomCareer">
          <div className="filter-search">
            <div className="filterTop">
              <AutoComplete
                className="autoComplete"
                placeholder="Find Your Dream Job..."
                onChange={handleSearchChange}
                value={searchValue}
                options={filteredPositions.map((career) => ({
                  value: career.name,
                  label: career.name,
                }))}
              />
              {/* <Select
                showSearch
                className="selectOption"
                placeholder="Select Department"
                optionFilterProp="children"
                onChange={handleDepartmentChange}
                value={selectedDepartment}
                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                filterSort={(optionA, optionB) => (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
                options={sortedDepartmentOptions}
              /> */}
              <Select
                showSearch
                className="selectOption"
                placeholder="Select Location"
                optionFilterProp="children"
                onChange={handleLocationChange}
                value={selectedLocation}
                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                filterSort={(optionA, optionB) => (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
                options={sortedLocationOptions}
              />
            </div>
          </div>
          <div className="middle">
            <div className="middleTitle">
              <p>
                {totalDisplayedData} jobs available {selectedDepartment ? `in department ${selectedDepartment}` : ''} {selectedLocation ? `in location ${selectedLocation}` : ''}.
              </p>
            </div>
            <div className="middleBody" style={{ display: totalDisplayedData === -1 ? 'none' : 'block' }}>
              <div className="top">
                <p className="nameCareer">Position</p>
                {/* <p className="departmentCareer">Department</p> */}
                <p className="locationCareer">Location</p>
              </div>
              {loading ? (
                <div className="loading-spinner">
                  <PuffLoader color="#007bff" size={100} margin={2} />
                </div>
              ) : (
                filteredPositions.slice(startIndex, endIndex).map((career, index) => (
                  <div className="body" key={index} onClick={() => handleBodyClick(career.id)}>
                    <p className="nameCareer">{career.name}</p>
                    {/* <p className="departmentCareer">{career.department}</p> */}
                    <p className="locationCareer">{career.location}</p>
                  </div>
                ))
              )}
            </div>
          </div>
          <div className="pagination">
            <Pagination current={currentPage} pageSize={pageSize} total={totalDisplayedData} onChange={(page) => setCurrentPage(page)} />
          </div>
        </div>
        <div className="footer">{isIdPath ? <FooterEn /> : <FooterId />}</div>
      </div>
      <CareerDetailEn selectedLoker={selectedLoker} open={open} setOpen={setOpen} />
    </div>
  );
};

export default Career;
